export default __webpack_public_path__ + "static/media/Keening Edge.da133ed4.jpg";